<template>
  <div class="place-self-center text-2xl"> Página não encontrada </div>
</template>
